export default __webpack_public_path__ + "static/media/notification-white.c3c1d461.svg";